export enum AccordionPanelCssVars {
  /**
   * The accordion panel's height.
   * @type {number}
   */
  accordionPanelHeight = '--accordion-panel-height',
  /**
   * The accordion panel's width.
   * @type {number}
   */
  accordionPanelWidth = '--accordion-panel-width',
}
